import { render, staticRenderFns } from "./productCertificate.vue?vue&type=template&id=4ba17a7d&scoped=true"
import script from "./productCertificate.vue?vue&type=script&lang=js"
export * from "./productCertificate.vue?vue&type=script&lang=js"
import style0 from "./productCertificate.vue?vue&type=style&index=0&id=4ba17a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba17a7d",
  null
  
)

export default component.exports